export const OCC_ENDPOINTS = {
  productAvailability: 'products/${productCode}/delivery',
  shopsByProduct: 'stores/stock/availability/${productCode}?fields=FULL',
  RRProductRecomendation: 'https://externalapi.retailrocket.ru/api/3.0/productRecommendations/alternatives',
  RRProductRelated: 'https://externalapi.retailrocket.ru/api/3.0/productRecommendations/related',
};
